<div class="cursor-pointer px-12 py-8 relative">
  <!-- Close Button -->
  <div class="absolute right-4 top-4">
    <button
      class="bg-ThemeWhisper h-7 w-7 rounded-full flex justify-center items-center outline-0 relative group"
      (click)="close()">
      <img src="../../../../../../../../assets/theme/images/icons/popup-cross.svg" alt="popup cross" />
      <div
        class="absolute top-1/2 right-full transform -translate-y-1/2 me-2 flex flex-col items-center hidden group-hover:flex">
        <span
          class="relative rounded-md z-10 px-3 py-1 font-medium text-[12px] leading-5 text-[#DBE0E7] whitespace-no-wrap bg-[#1D232A] shadow-lg">
          <span>Close</span>
          <span class="text-[#2F3A46] ms-2.5">Esc</span>
        </span>
        <div
          class="w-2 h-2 rotate-45 bg-[#1D232A] absolute top-1/2 right-[-4px] transform -translate-y-1/2">
        </div>
      </div>
    </button>
  </div>

  <!-- Title & Message -->
  <h2 class="text-xl font-semibold text-[#181D27] mb-1">{{this.data.title}}</h2>
  <p class="font-medium  text-sm text-themeCharcoal">
   {{this.data.description}}
  </p>

  <!-- Buttons -->
  <div class="mt-6 flex justify-end gap-2">
    <button
      (click)="close()"
      class="items-center justify-center border border-[#E3E3E3] py-[9px] px-4 rounded-full font-Inter text-xs leading-5 text-[#111111] font-medium">
      Cancel
    </button>
    <button
      (click)="close(true)"
      class="bg-[#121212] rounded-full text-white py-[9px] px-4 items-center justify-center border border-[#121212] font-Inter text-xs leading-5 font-medium">
      {{this.data.buttonTitle}}
    </button>
  </div>
</div>
